'use client'
import styles from './page.module.css'
import { useTranslations } from 'next-intl'
import { useState } from 'react'
import ForgotPassword_Step1 from './Step1/step1'
import ForgotPassword_Step2 from './Step2/step2'
import ForgotPassword_Step3 from './Step3/step3'

export enum ForgotPasswordSteps {
	STEP_1 = 1,
	STEP_2 = 2,
	STEP_3 = 3
}

export default function ForgotPassword() {
	const t = useTranslations('ForgotPassword')
	const [username, setUsername] = useState<string | null>(null)
	const [step, setStep] = useState(ForgotPasswordSteps.STEP_1)
	const [code, setCode] = useState<string | null>(null)

	/**
	 * Handles the transition between steps in the forgot password flow
	 * 
	 * @param step - The new step
	 */
	function handleStepChange(step: ForgotPasswordSteps) {
		setStep(step)
	}

	/**
	 * Handles the username update in the parent component state,
	 * which is used across different steps of the forgot password flow 
	 * 
	 * @param userName - The username to set in the parent component state
	 */
	function handleSetUsername(userName: string) {
		setUsername(userName)
	}

	return (
		<div className={styles.main}>
			<div className={styles.titleWrapper}>
				<p data-testid='ForgotPassword_stepCounter' className={`bodyTextMedium ${styles.counter}`}>{t('stepCounter', {step: step})}</p>
				<h1 data-testid='ForgotPassword_title' className={`title2 ${styles.title}`}>{t('title')}</h1>
			</div>

			{step === ForgotPasswordSteps.STEP_1 && <ForgotPassword_Step1 setStep={handleStepChange} setUsername={handleSetUsername} />}
			{step === ForgotPasswordSteps.STEP_2 && <ForgotPassword_Step2 username={username!} setStep={handleStepChange} setCode={setCode} />}
			{step === ForgotPasswordSteps.STEP_3 && <ForgotPassword_Step3 username={username!} setStep={handleStepChange} code={code}/>}
		</div>
	)
}